<template>
  <div class="technical-support">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="technical-support__title">
      Technical Support
    </div>
    <BBTable
      :columns="columns"
      :rows="items"
      :noData="!items.length"
      :page="queryParams.page"
      :limit="queryParams.limit"
      :maxHeight="maxHeight"
      @filter="changeFilter"
      @edit="edit"
    />
    <Pagination
      :data="queryParams"
      :getQuery="toggleSupportPages"
      :limit="queryParams.limit"
      class="bb-pagination"
    />
  </div>
</template>

<script>
import technicalSupportTableColumns from '@/constants/TablesOptions/technicalSupportTable'
import BBTable from '@/components/Main/BBTable/BBTable'
import Pagination from '@/components/Main/Pagination/Pagination'
import TechnicalSupportApi from '@/api/TechnicalSupport/api'
import {CATEGORY_TECHNICAL_SUPPORT} from '@/constants/categoryTechnicalSupport'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'

export default {
  name: 'TechnicalSupport',
  components: {
    BBTable,
    Pagination,
    LoaderFly,
  },
  data: () => ({
    loaderRun: false,
    columns: JSON.parse(JSON.stringify(technicalSupportTableColumns)),
    items: [],
    queryParams: {
      page: 1,
      limit: 20
    },
    filter: {
      category: [],
      status: [],
      user: []
    },
  }),
  computed: {
    maxHeight () {
      const { totalDocs, limit } = this.queryParams
      return `calc(100vh - ${totalDocs < limit ? 177 : 244}px)`
    },
    newSuggestion ()  {
      return this.$store.getters.newTechnicalSuggestion;
    }
  },
  watch: {
    newSuggestion (newValue) {
      if (newValue) {
        this.items.unshift(newValue);
        this.$store.dispatch('removeNewTechnicalSuggestion');
      }
    }
  },
  methods: {
    changeFilter (res) {
      const { prop, id, checked } = res
      const index = this.filter[prop].indexOf(id)
      if (checked) {
        this.filter[prop].push(id)
      } else if (index !== -1) {
        this.filter[prop].splice(index, 1)
      }
      this.getTechnicalSupports({page: 1})
    },
    async edit ({row = {}}) {
      const {_id, status} = row
      try {
        await TechnicalSupportApi.editTechnicalSupports(_id, {status})
      } catch (err) {
        console.error(err)
      }
    },
    async getTechnicalSupports ({page}) {
      const { limit } = this.queryParams
      const { category, status, user } = this.filter
      const query = {
        page,
        limit,
        category: category.join('&category[]='),
        status: status.join('&status[]='),
        user: user.join('&user[]=')
      }

      const { data } = await TechnicalSupportApi.getTechnicalSupports(query)
      const { supports = [], limit: supportsLimit } = data
      supports.forEach((s) => {
        s.category = CATEGORY_TECHNICAL_SUPPORT.find((el) => el.id === s.category).name
      })
      this.items = supports

      this.queryParams = {
        ...data,
        limit: Number(supportsLimit)
      }
    },
    async getSelectFilterTechnicalSupports () {
      const { data } = await TechnicalSupportApi.getSelectFilterTechnicalSupports()
      const column = this.columns.find((c) => c.filterProp === 'user')
      data.forEach((el) => {
        el.checked = false
        el.id = el._id
      })
      column.filterBy = data
    },
    async toggleSupportPages (data) {
      this.loaderRun = true;
      try {
        await this.getTechnicalSupports(data);
      } catch (err) {
        console.error(err)
      } finally {
        this.loaderRun = false;
      }
    },
  },
  beforeMount () {
    const getAllData = async () => {
      this.loaderRun = true;
      try {
        await Promise.all([
          this.getSelectFilterTechnicalSupports(),
          this.getTechnicalSupports({}),
        ])
      } catch (err) {
        console.error(err)
      } finally {
        this.loaderRun = false;
      }
    }

    getAllData();

  }
}
</script>

<style scoped lang="scss">
@import "../../sass/variables";

  .technical-support {

    &__title {
      font-size: 25px;
      line-height: 30px;
      font-weight: 600;
      color: $color-denim;
      margin: 0 0 15px 0;
    }
  }
</style>

<style  lang="scss">
@import "../../sass/variables";

  .technical-support {

    .bb-table-body {
      padding: 0 0 9px 0 !important;
      margin: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TechnicalSupport/TechnicalSupport.vue